import { selector } from "./selector";
import { gSelector } from "../../../app/selector";
import * as form from "../../../app/form";
import { crud } from "../../../app/crud";
import { formFields, sentFormFields, lostTagFormFields, mlffFormFields, mlffSentFormFields } from "./form-fields";
import { translate } from "../../../app/localisation";

let isClick = false
let isMlffClick = false

const validateMlffForm = function ($form) {
    const errors = {};
    const serialNumber = $form.find('input[name="serialNumber"]').val().trim();
    const serialNumberConfirmation = $form.find('input[name="serialNumber_confirmation"]').val().trim();
    const verificationCode = $form.find('input[name="verificationCode"]').val().trim();

    if (!serialNumber) {
        errors.serialNumber = translate('mlffSerialRequired');
    }
    if (!serialNumberConfirmation) {
        errors.serialNumber_confirmation = translate('mlffSerialConfirmRequired');
    }
    if (!verificationCode) {
        errors.verificationCode = translate('mlffPlateRequired');
    }
    if (serialNumber && serialNumberConfirmation && serialNumber !== serialNumberConfirmation) {
        errors.serialNumber_confirmation = translate('mlffSerialMismatch');
    }
    return errors;
};

const createMlffModalAction = function (e) {
    let $modal = e.data.modal;
    let $form = $modal.find('form');
    let url = '/customer/tags/add-tag/mlff';

    if (isMlffClick) {
        return
    }

    form.removeErrorMessages($form, mlffFormFields);
    $form.find(gSelector.modal.errors.general).html('').hide();

    const validationErrors = validateMlffForm($form);
    if (Object.keys(validationErrors).length > 0) {
        for (const field in validationErrors) {
            const fieldConfig = mlffFormFields.find(f => f.field === field);
            if (fieldConfig) {
                const $field = $form.find(fieldConfig.selector);
                $field.addClass('is-invalid');
                $field.after('<div class="text-danger">' + validationErrors[field] + '</div>');
            }
        }
        return;
    }

    isMlffClick = true
    $modal.find('.loader').css('display', 'block');

    crud.create(url, form.getFormData($form, mlffSentFormFields))
        .done((jqXHR) => {
            $modal.find('.loader').css('display', 'none');
            $modal.find(gSelector.btn.modal.save).addClass('successfully');
            form.handleSuccessResponse($form, true, jqXHR);
        })
        .fail((jqXHR) => {
            isMlffClick = false;
            $modal.find('.loader').css('display', 'none');
            form.handleFailResponse($form, mlffFormFields, jqXHR);
        });
}

const createModalAction = function (e) {
    let $modal = e.data.modal;
    let $form = $modal.find('form');
    let url = '/customer/tags/add-tag';
    let urlMne = '/customer/tags/add-tag/mne';
    let urlHr = '/customer/tags/add-tag/hr';

    if (isClick) {
        return
    }

    isClick = true

    form.removeErrorMessages($form, formFields);
    const userCountry = $(selector.country).val();

    switch (userCountry) {
        // case 'HR':
        //     url = urlHr;
        //     while (sentFormFields.length > 0) {
        //         sentFormFields.pop();
        //     }

        //     sentFormFields.push({ field: 'tagType', selector: 'input[name="hr_tag_type"]:checked' });

        //     if ($(selector.hr.tagTypeGeaRadio).is(':checked')) {
        //         sentFormFields.push({ field: 'serialNumber', selector: '#hr_gea_container input[name="serialNumber"]' });
        //         sentFormFields.push({ field: 'serialNumber_confirmation', selector: '#hr_gea_container input[name="serialNumber_confirmation"]' });
        //     }

        //     if ($(selector.hr.tagTypeQFreeRadio).is(':checked')) {
        //         sentFormFields.push({ field: 'serialNumber', selector: '#hr_qfree_container input[name="serialNumber"]' });
        //         sentFormFields.push({ field: 'serialNumber_confirmation', selector: '#hr_qfree_container input[name="serialNumber_confirmation"]' });
        //     }

        //     break;
        case 'ME':
            url = urlMne;
            break;
    }

    $(selector.addTagLoader).css('display','block')

    crud.create(url, form.getFormData($form, sentFormFields))
        .done((jqXHR) => {
            $(selector.addTagLoader).css('display', 'none')
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, true, jqXHR)
        })
        .fail((jqXHR) => {
            isClick = false
            $(selector.addTagLoader).css('display', 'none')
            form.handleFailResponse($form, formFields, jqXHR)
        });
}

const addTagModal = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    let $modal = $(selector.modal.add).modal('show');

    let $form = $modal.find('form');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, formFields);
        form.resetFormData($form, sentFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully'))
            window.location.reload()
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal }, createModalAction);
    $modal.find(gSelector.btn.modal.close).off('click').on('click', function () { window.location.reload() });
}

const addMlffTagModal = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    let $modal = $(selector.modal.addMlff).modal('show');
    let $form = $modal.find('form');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function () {
        form.removeErrorMessages($form, mlffFormFields);
        form.resetFormData($form, mlffSentFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal }, createMlffModalAction);
    $modal.find(gSelector.btn.modal.close).off('click').on('click', function () { window.location.reload(); });
}

const sendLostTagAction = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/lost';
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR)
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 4000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const openLostTagModal = function (e) {
    e.preventDefault();

    const $modal = $(selector.modal.lostTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);

        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber }, sendLostTagAction);
}

const openFoundTagModal = function (e) {
    const $modal = $(selector.modal.foundTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber }, sendFoundTagAction);
}

const sendFoundTagAction = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/found';
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 4000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const hrTagTypeChange = function (e) {
    if ($(selector.hr.tagTypeGeaRadio).is(':checked')) {
        $(selector.hr.tagTypeGeaContainer).show();
        $(selector.hr.tagTypeQFreeContainer).hide();
    } else if ($(selector.hr.tagTypeQFreeRadio).is(':checked')) {
        $(selector.hr.tagTypeGeaContainer).hide();
        $(selector.hr.tagTypeQFreeContainer).show();
    }
}

const openActivateTagModal = function (e) {
    console.log($(selector.modal.activateTag))
    const $modal = $(selector.modal.activateTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');
    let country = $(e.target).data('country');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber, country }, sendTagActivate);
}

const sendTagActivate = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let country = e.data.country;
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/activate/' + country;
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const openDeactivateTagModal = function (e) {
    console.log($(selector.modal.deactivateTag))
    const $modal = $(selector.modal.deactivateTag).modal('show');
    let $form = $modal.find('form');
    let serialNumber = $(e.target).data('tag');
    let country = $(e.target).data('country');

    $modal.off('hide.bs.modal').on('hide.bs.modal', function (e) {
        form.removeErrorMessages($form, lostTagFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass('successfully')) {
            window.location.reload();
        }
    });

    $modal.find(gSelector.btn.modal.save).off('click').on('click', { modal: $modal, serialNumber, country }, sendTagDeactivate);
}

const sendTagDeactivate = function (e) {
    let $modal = e.data.modal;
    let serialNumber = e.data.serialNumber;
    let country = e.data.country;
    console.log(country)
    let $form = $modal.find('form');
    let url = '/customer/tags/' + serialNumber + '/deactivate/' + country;
    let $submitButton = $modal.find(gSelector.btn.modal.save);
    form.removeErrorMessages($form, lostTagFormFields);
    crud.create(url)
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass('successfully')
            form.handleSuccessResponse($form, false, jqXHR);
            $submitButton.prop('disabled', true);
            setTimeout(function () {
                location.reload();
            }, 2000);
        })
        .fail((jqXHR) => form.handleFailResponse($form, lostTagFormFields, jqXHR.responseText));
}

const openEditNicknameModal = function (e) {
    const $button = $(e.currentTarget);
    const nickname = ($button.data('nickname') || '').toString();
    const serialNumber = ($button.data('tag') || '').toString();
    const $modal = $($button.data('bs-target'));
    const $saveButton = $modal.find(gSelector.btn.modal.save);
    const modalTitle = ($button.attr('title') || '').toString().trim();

    $modal.find(selector.editNicknameInput).val(nickname);
    if (modalTitle !== '') {
        $modal.find('.modal-title').text(modalTitle);
    }
    $modal.data('serialNumber', serialNumber);

    $saveButton.off('click').on('click', function () {
        const value = ($modal.find(selector.editNicknameInput).val() || '').toString().trim();
        const payload = new FormData();
        payload.append('nickname', value);
        const url = '/customer/tags/' + serialNumber + '/nickname';

        crud.update(url, payload)
            .done(() => {
                window.location.reload();
            })
            .fail((jqXHR) => {
                const message = jqXHR?.responseJSON?.errors?.nickname?.[0]
                    || jqXHR?.responseJSON?.errors?.[0]
                    || jqXHR?.responseJSON?.message
                    || 'Greška pri čuvanju nadimka';
                $modal.find(gSelector.modal.errors.general).html(message).show();
            });
    });
};

export {
    addTagModal,
    addMlffTagModal,
    openLostTagModal,
    openFoundTagModal,
    hrTagTypeChange,
    openActivateTagModal,
    openDeactivateTagModal,
    openEditNicknameModal
};
